<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="point-of-origin">
<h1 class="main">Point of Origin</h1>
<p><em>There is nothing vast that enters into human life without a curse.</em></p>
<p style="text-align: right;">—Sophocles <em>Antigone</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1a757bf3